import { create } from "zustand";
import { persist } from "zustand/middleware";

declare global {
  interface Window {
    config?: {
      apiUrl?: string;
      s3Prefix?: string;
      models?: Array<{
        ID: string;
        label: string;
        description: string;
        provider: string;
        cost: string;
        advanced: boolean;
      }>;
    };
  }
}

export const DEFAULT_API_URL = "http://127.0.0.1:5000";
export const DEFAULT_S3_PREFIX = "";

function getConfigApiUrl(): string {
  return window.config?.apiUrl ?? DEFAULT_API_URL;
}

function getConfigS3Prefix(): string {
  return window.config?.s3Prefix ?? DEFAULT_S3_PREFIX;
}

export type SettingsState = {
  apiUrl: string;
  /**
   * Umgebungs-Präfix des `botpilotfiles`-S3-Buckets (client.md §10). Der Wert steckt
   * serverseitig in der DynamoDB-Parameter-Tabelle (`util.s3prefix`, z. B. "" für Prod,
   * "demo-" oder "test-") und wird von keinem botagent-Endpunkt zurückgegeben — der Client
   * kann ihn nicht ableiten, sondern muss ihn genau wie apiUrl pro Deployment kennen.
   */
  s3Prefix: string;
  notifications: boolean;
  pollSeconds: number;
  classic: boolean;
  setApiUrl: (url: string) => void;
  setS3Prefix: (prefix: string) => void;
  setNotifications: (on: boolean) => void;
  setClassic: (on: boolean) => void;
};

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      apiUrl: getConfigApiUrl(),
      s3Prefix: getConfigS3Prefix(),
      notifications: true,
      classic: false,
      pollSeconds: 10,
      setApiUrl: (url) => set({ apiUrl: url }),
      setS3Prefix: (prefix) => set({ s3Prefix: prefix }),
      setNotifications: (on) => set({ notifications: on }),
      setClassic: (on) => set({ classic: on }),
    }),
    { name: "botagent.settings.v1" },
  ),
);
